module.exports = __webpack_public_path__ + "img/spirit_small_2.0c492c68.png";